import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { createContext, useContext } from "react";
const PortalContext = createContext(void 0);
const PortalProvider = (t0) => {
  const $ = c(3);
  const {
    container,
    children
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== container) {
    t1 = /* @__PURE__ */ jsx(PortalContext.Provider, { value: container, children });
    $[0] = children;
    $[1] = container;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
function usePortalContainer() {
  return useContext(PortalContext);
}
export {
  PortalProvider,
  usePortalContainer
};
//# sourceMappingURL=index.js.map
